<template lang='pug'>
v-flex 
  v-layout
    dataPickerCombobox(type='Kardex' :data = '({item: itemToGetKardex, warehouse: warehouseToGetKardex})' )
  v-card
    v-card-title Kardex
      v-spacer

      v-form(autocomplete='false')
        v-layout 
          v-autocomplete( v-model="itemToGetKardex" type='text' label='Seleccionar producto' :item-text='item=>`${item.codigo} - ${item.descripcion} ${item.presentacion}`' :items="productsRecord" item-value="key" )
          v-autocomplete.ml-2( v-model="warehouseToGetKardex" label='Seleccionar almacén' item-text='name' :items="warehouseRecord" item-value="slug" )  
          template( v-slot:append-outer )
            v-slide-x-reverse-transition( mode='out-in' )
    v-data-table.elevation-1( sortby-text='Ordenar por' :headers='headers' :items='kardex' :footer-props="footerProps"  )
      template( v-slot:headers='props')
        tr
          template( v-for='header, i in headers')
            th.text-center(v-if="header.colspan>0" :colspan='header.colspan ? header.colspan : 0') {{header.parent}}
        tr
          th.text-center( v-for="header in props.headers" :key="header.value" :class="['column sortable', options.descending ? 'desc' : 'asc', header.value === options.sortBy ? 'active' : '']" @click="changeSort(header.value)")
            v-icon(small='') fas fa-sort-up
            span {{ header.text }}

      template( v-slot:item.numero="{item}" )
        td {{ item.documento }} Nº {{ item.numero }}
        

  printerButtons(:dataToPrint = 'kardex')
  
</template>
<style lang="sass">
  table
    tbody 
      tr:first-child
        border-top: 1px solid rgba(0,0,0,.16)!important
    thead
      tr:first-child
        border-bottom: unset!important
    
</style>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  data: ()=>({
    itemToGetKardex: '',
    warehouseToGetKardex: '',
    headers:[
      { text: 'Nº',                 value: 'numero_de_kardex',              colspan:'1'                       },
      { text: 'Documento',          value: 'numero',                        colspan:'1'                       },
      { text: 'Registrado por',     value: 'creado_por',                    colspan:'1'                       },
      { text: 'Fecha',              value: 'creado_el',                     colspan:'1'                       },
      { text: 'Motivo de traslado', value: 'nombre_motivo_de_traslado',     colspan:'1'                       },
      { text: 'Almacén de origen',  value: 'almacen_de_origen',             colspan:'1'                       },
      { text: 'Almacén de destino', value: 'almacen_de_destino',            colspan:'1'                       },
      { text: 'Costo',              value: 'entradas_costo',                colspan:'4',  parent:'Entrada'    },
      { text: 'Cantidad',           value: 'entradas_cantidad',             colspan:'0'                       },
      { text: 'Total',              value: 'entradas_total',                colspan:'0'                       },
      { text: 'Subtotal',           value: 'entradas_subtotal',             colspan:'0'                       },
      { text: 'Costo',              value: 'salidas_costo',                 colspan:'3',  parent:'Salida'     },
      { text: 'Cantidad',           value: 'salidas_cantidad',              colspan:'0'                       },
      { text: 'Total',              value: 'salidas_total',                 colspan:'0'                       },
      { text: 'Costo',              value: 'existencias_costo',             colspan:'3',  parent:'Existencia' },
      { text: 'Cantidad',           value: 'existencias_cantidad',          colspan:'0'                       },
      { text: 'Total',              value: 'existencias_total',             colspan:'0'                       },
    ],
     
    footerProps: {
      'items-per-page-options':   [15, 30, 50]
    }
  }),
  computed: {
    ...mapGetters({
      productsRecord: 'Product/record',
      kardex: 'Kardex/getKardex',
      warehouseRecord: 'Warehouse/record',
    })
  },

  methods:{
    ...mapActions({
      getItemFromWarehouseKardex: 'Kardex/getAll',
    }),
   
  },
  watch:{
    itemToGetKardex(){
      this.getItemFromWarehouseKardex({item: this.itemToGetKardex, warehouse: this.warehouseToGetKardex})
    },
    warehouseToGetKardex(){
      this.getItemFromWarehouseKardex({item: this.itemToGetKardex, warehouse: this.warehouseToGetKardex})
    },
  },
  components:{
    dataPickerCombobox: ()=>import('../components/dataPickerCombobox'),
    printerButtons: ()=>import('../components/printerButtons'),
  },


}
</script>

